export default __webpack_public_path__ + "static/media/TR-ar.83f17cb3.svg";